import React from 'react';
import House1 from './Assets/Images/House1.jpeg';
import ScrollCounter from './ScrollCounter';

const Achievements = () => {
  return (
    <div>
      <div
        className="bg-cover bg-center bg-fixed min-h-screen"
        style={{ backgroundImage: `url(${House1})` }}
      >
        <div className="bg-black bg-opacity-50 min-h-screen px-4 md:px-15 py-20 text-white">
          <div className="flex flex-col lg:flex-row gap-10">
            
            {/* Left Content with Custom Border */}
            <div className="relative h-[50vh] lg:h-[70vh] w-full lg:w-1/2 p-6 md:p-10 flex flex-col justify-between">
              {/* Top Border */}
              <div className="absolute top-0 left-0 w-full h-[15px] bg-white z-0" />
              {/* Bottom Border */}
              <div className="absolute bottom-0 left-0 w-full h-[15px] bg-white z-0" />
              {/* Left Border */}
              <div className="absolute top-0 left-0 h-full w-[15px] bg-white z-0" />
              {/* Right Top 30% Border */}
              <div className="absolute top-0 right-0 h-[35%] w-[15px] bg-white z-0" />
              {/* Right Bottom 30% Border */}
              <div className="absolute bottom-0 right-0 h-[35%] w-[15px] bg-white z-0" />

              {/* Content Inside Border */}
              <div className="relative z-10">
                <h1 className="text-3xl md:text-5xl mb-8">Our Achievements</h1>
                <h2 className="text-3xl md:text-6xl font-extrabold mb-6">To Our Excellence</h2>
                <p className="text-xl md:text-lg">
                  At Ram Engineer, our journey has been marked by several milestones that reflect our unwavering commitment to delivering exceptional interior design and construction solutions.
                </p>
              </div>
            </div>

            {/* Right Counter Section */}
            <div className="flex flex-wrap lg:flex-col gap-10 lg:gap-12 justify-around items-center w-full lg:w-1/2 p-4 lg:p-0">
              {[
                { label: "Happy Clients", count: 120 },
                { label: "Finished Projects", count: 75 },
                { label: "Working Days", count: 365 },
              ].map((item, index) => (
                <div key={index} className="text-center">
                  <ScrollCounter end={item.count} />
                  <div className="border-t-2 border-white w-16 mx-auto my-2" />
                  <p className="font-bold">{item.label}</p>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Achievements;
